"use client";
import { useLocale } from "next-intl";
import useLocaleSwitcherModal from "../hooks/useLocaleSwitcherModal";
import Icon from "../../../modules/common/components/Icon";

const LocaleSwitcher = ({ displayIs0 = false }) => {
  const locale = useLocale();
  const { openLocaleSwitcher, supportedLocales, LocaleSwitcherModal } =
    useLocaleSwitcherModal();
  return (
    <>
      <button
        onClick={(e) => {
          e.stopPropagation();
          e.preventDefault();
          openLocaleSwitcher();
        }}
        className="d-flex align-items-center gap-2"
      >
        {displayIs0 ? locale : supportedLocales[`locale_${locale}`]}
        <Icon icon="chevron-small" className="icon--md" />
      </button>
      {LocaleSwitcherModal}
    </>
  );
};

export default LocaleSwitcher;
